import { get, postj } from '@/utils/request';

export const list = (param) => get('product/list',param); // 订单列表
export const productDel = (data) => postj('product/del',data); // 删除
export const productAdd = (data) => postj('product/add',data); // 新增
export const productUpdate = (data) => postj('product/update',data); // 编辑